 var ISApp = {
  modalInsu: null,
  objInsurance: {},
  url: {
    getCollection: 'https://tanervm265.execute-api.us-west-2.amazonaws.com/prod/getByCollectionId',
    getByPrice: 'https://cznn87skc5.execute-api.us-west-2.amazonaws.com/prod/getByPrice',
    getModels: 'https://cznn87skc5.execute-api.us-west-2.amazonaws.com/prod/getModels',
    addCart: 'cart/add.js',
    img:{
      check: 'https://cdn.shopify.com/s/files/1/0713/2368/1056/files/tick_grey.svg?v=1711632475'
    }
  },
  brands: {},
  init: async function() {
    var self = this;
    this.bindEvents();
    this.updateBrandOptions($('#product-type').val());
    // Traigo los modelos
    await axios.get(ISApp.url.getModels).then((response) => {
      var models = response.data.data.data;
      console.log("getModels ==>", models);

      var types = new Set();
      for (let i = 0; i < models.length; i++) {
        const model = models[i];
        types.add(model.type);
      }
  
      var options = '';
        options += '<option value="">Seleccione...</option>';
      types.forEach(type => {
        options += '<option value="' + type + '">' + type + '</option>';
      });
      $('#product-type').html(options);

      for (let i = 0; i < models.length; i++) {
        const model = models[i];
        if (!ISApp.brands[model.type]) {
          ISApp.brands[model.type] = [];
        }
        ISApp.brands[model.type].push({ brand: model.brand, model: model.model });
      }
    }).catch(error => {
      console.log("Error al intentar obtener los precios: ", error);
    });
    // Seteo fecha maxima al campo fecha compra
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); // Enero es 0!
    var yyyy = today.getFullYear();
    today = yyyy + '-' + mm + '-' + dd;
    
    // Calcular la fecha mínima permitida (36 meses antes)
    var minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 36);
    var minDd = String(minDate.getDate()).padStart(2, '0');
    var minMm = String(minDate.getMonth() + 1).padStart(2, '0'); // Enero es 0!
    var minYyyy = minDate.getFullYear();
    minDate = minYyyy + '-' + minMm + '-' + minDd;
    
    // Establecer los atributos max y min del campo de fecha
    $('#purchase-date').attr('max', today);
    $('#purchase-date').attr('min', minDate);
    $('input[name="insu-rut-type"]').on('change', function() {
      $('[for="insu-rut"] span').text($(this).val() === "1" ? 'DNI' : 'RUC');
    });
  },

  bindEvents: function() {
    var self = this;
    $('#getPlans').on('click', function() {
      var productType = $('#product-type').val();
      var purchasePrice = $('#purchase-price').val();
      console.log(productType, purchasePrice);
      self.getByPrice(productType, purchasePrice);
    });

    $('#clean').on('click', function() {
      console.log("clean");
      $('#product-type, #brand, #model, #purchase-date, #purchase-price').val("");
      $('#brand, #model').empty();
    });
    
    $('#purchase-price').on('blur', function() {
      var priceInput = parseFloat($(this).val());
      if (!isNaN(priceInput)) {
          var adjustedPrice = priceInput.toFixed(2);
          var parts = adjustedPrice.split('.');
          var integerPart = parts[0];
          var decimalPart = parts[1];
          
          var formattedPrice = 'S/ ' + integerPart + '.' + decimalPart;
    
          console.log("Precio ajustado:", formattedPrice);
          $(this).val(formattedPrice);
      }
    });

    $('#product-type').on('change', function() {
      var tipoSeleccionado = $(this).val();
      self.updateBrandOptions(tipoSeleccionado);
    });

    $('#brand').on('change', function() {
      var marcaSeleccionada = $(this).val();
      ISApp.updateModelOptions(marcaSeleccionada);
    });

    $('#btnAceptar').on('click', function() {
      var dispositivoSeleccionado = $('#dispositivos').val();
      var modeloSeleccionado = $('#modelos').val();
      self.enviarDatosAlServidor(dispositivoSeleccionado, modeloSeleccionado);
    });

    $('#product-type, #brand, #purchase-date, #purchase-price').on('input', function() {
        self.checkFields();
      });
    
    $('body').on('click', '.insurance', function(event) {
      if ($(event.target).hasClass('ver-mas')) {
          return;
      }
      ISApp.checkModalDatos.call(this);
    });

    $('body').on('change', '#insu-fnac', function() {
        var selectedDate = new Date($(this).val());
        var today = new Date();
        var minDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

        if (selectedDate > minDate) {
            alert('Debes tener al menos 18 años.');
            $(this).val(''); 
        }
    });

    $('body').on('click', '.ver-mas', function() {
      let index = $(this).data('index');
      let description = $('.insurance-description');
      let insurance = $(this).closest('.insurance');
    
      if (!description.hasClass('animate__animated')) {
        if (insurance.hasClass('expanded')) {
          ISApp.mostrarMenos(insurance, description);
        } else {
          ISApp.mostrarMas(insurance, description);
        }
      }
    });

    $('body').on('click', '#btn-ok-insu', function(event) {
      ISApp.addToCart();
    });
  },
   mostrarMas: function (insurance, description) {
    $('.insurance').not(insurance).hide(300);
  
    insurance.removeClass('col-lg-4');
    anime({
      targets: insurance,
      width: '100%',
      duration: 300,
      easing: 'easeOutQuint',
    });
    anime({
        targets: description,
        translateX: 270,
        easing: 'easeInElastic(1, .6)'
      });
    setTimeout(function() {
      description.fadeIn();
    }, 300);
  
    $('.ver-mas', insurance).text('Ver menos');
    insurance.addClass('expanded');
  },
  mostrarMenos: function (insurance, description) {
    $('.insurance').not(insurance).show(300);
  
    anime({
      targets: insurance,
      width: '33.33%',
      duration: 100,
      easing: 'easeOutQuint',
    });
  
    anime({
      targets: description,
      opacity: 0,
      scale: 0.8,
      duration: 100,
      easing: 'easeInElastic',
      complete: function() {
        description.hide();
        insurance.addClass('col-lg-4');
      },
    });
  
    $('.ver-mas', insurance).text('Ver más');
    insurance.removeClass('expanded');
  },
  updateBrandOptions: function(tipoSeleccionado) {
      var options = '';
      console.log("tipoSeleccionado =>", tipoSeleccionado);
      console.log("ISApp.brands =>", ISApp.brands);
    
      if (ISApp.brands[tipoSeleccionado]) {
          var marcas = ISApp.brands[tipoSeleccionado];
          var uniqueBrands = new Set();

          Object.keys(marcas).forEach(function(brandIndex) {
              var brandName = marcas[brandIndex].brand;
              uniqueBrands.add(brandName);
          });

          var sortedBrands = Array.from(uniqueBrands).sort();
          options += '<option value="">Seleccione...</option>';

          sortedBrands.forEach(function(brandName) {
              options += '<option value="' + brandName + '">' + brandName + '</option>';
          });
      } else {
          options += '<option value="">Tipo no encontrado</option>';
      }
    
      $('#brand').html(options);
      $('#model').empty();
  },
  updateModelOptions: function(marcaSeleccionada) {
      var modelos = ISApp.brands[$('#product-type').val()].filter(function(item) {
          return item.brand === marcaSeleccionada;
      }).map(function(item) {
          return item.model;
      }).sort(function(a, b) {
          return a.localeCompare(b, 'es', {ignorePunctuation: true});
      });
  
      var options = '';
      $.each(modelos, function(index, modelo) {
          options += '<option value="' + modelo + '">' + modelo + '</option>';
      });
      $('#model').html(options);
  },
  checkFields: function() {
      var productType = $('#product-type').val();
      var brand = $('#brand').val();
      var purchaseDate = $('#purchase-date').val();
      var purchasePrice = $('#purchase-price').val();
      var allFieldsFilled = productType && brand && purchaseDate && purchasePrice;

      $('#getPlans').prop('disabled', !allFieldsFilled);
  },
  getByPrice: function(tipoDispositivo, precio) {
    let html = '';
    const formattedPrice = precio.replace('S/', '').trim();
    axios.post(ISApp.url.getByPrice, { price: Number(formattedPrice), category: String(tipoDispositivo) }).then((response) => {
      console.log("response ==>", response.data.data);
      let seguros = response.data.data
      if(seguros.length > 0){
        const descp1 = "<div><ul> <li>Cubre la rotura accidental de tu pantalla</li><li>Cobertura por 12 meses desde el momento de la compra del equipo (no hay carencia)</li><li>Reparación en nuestra red nacional de servicios técnicos</li><li>Sin deducible, no pagas en nada en caso de reparación</li><li>Cobertura mundial, cuando vuelvas a tu país, repararemos tu equipo</li><li>Contrata 100% online</li><li>Denuncia de siniestro digital</li></ul></div>";
        const descp2 = "<div><ul> <li>Cubre robo y hurto (no cubre perdida)</li><li>Cobertura por 12 meses desde el momento de la compra del equipo (no hay carencia)</li><li>Reemplazo por el mismo equipo o de similares características, sin ningún costo adicional (no hay deducible)</li><li>Cobertura mundial, cuando vuelvas a tu país, reemplazaremos tu equipo.</li><li>Contrata 100% online</li><li>Denuncia de siniestro digital</li></ul></div>";
        const descp3 = "<div><ul> <li>Cubre rotura accidental de tu equipo, daños por líquido y además robo y hurto (no cubre perdida)</li><li>Cobertura por 12 meses desde el momento de la compra del equipo (no hay carencia)</li><li>Reparación en nuestra red nacional de servicios técnicos</li><li>Sin deducible, no pagas en nada en caso de reparación o reemplazo del equipo</li><li>Cobertura mundial, cuando vuelvas a tu país, repararemos o reemplazaremos tu equipo</li><li>Denuncia hasta 2 siniestros al año (1 de robo y 1 de daño)</li><li>Contrata 100% online</li><li>Denuncia de siniestro digital</li></ul></div>";
        for (let index = 0; index < seguros.length; index++) {
          console.log("Seguro =>", seguros[index].name);
          let formattedPrice = seguros[index].price.toLocaleString('es-PE', { style: 'currency', currency: 'PEN' });
          let formattedPriceDiscounted = seguros[index].price_discounted.toLocaleString('es-PE', { style: 'currency', currency: 'PEN' });
          html += '<div class="insurance col-12 col-lg-4 mb-2">'
          html += '<div class="insurance_content">'
          html += '<h3>' + ((seguros[index].product_id === 1 || seguros[index].product_id === 15) ? 'Básico' : ((seguros[index].product_id === 25 || seguros[index].product_id === 23) ? "Sólo Robo" : "Top")) + '</h3>';
          html += '<input type="radio" name="insurance" id="insurance' + (index + 1) + '">'
          // html += '<label for="insurance' + (index + 1) + '" class="insurance-title" style="color:#0072c2">S/. ' + formattedPrice + '</label>'
          html += '<div><label for="insurance' + (index + 1) + '" class="insurance-title-old" style="color:#949494;text-decoration: line-through;font-weight: bold;font-size: 1.2em;margin-bottom: 10px;">S/. ' + formattedPrice + '</label><label for="insurance_discounted' + (index + 1) + '" class="insurance-title" style="color:#0072c2">S/. ' + formattedPriceDiscounted + '</label></div>'
          html += (index === 0) ? '<p class="insurance-coverage">Cubre: <strong>Robo con y sin violencia</strong></p>' : (index === 1) ? '<p class="insurance-coverage">Cubre: <strong>Daño de Pantalla</strong></p>' : '<p class="insurance-coverage">Cubre: <strong>Daño Pantalla, Daño producto de agua y Robo</strong></p>'
          html += (index === 0) ? '<div class="insurance-description">' + descp2 + '</div>' : (index === 1) ? '<div class="insurance-description">' + descp1 + '</div>' : '<div class="insurance-description">' + descp3 + '</div>'
          html += '<span class="ver-mas" data-index="' + index + '">Ver más</span>';
          html += '</div>'
          html += '</div>'
        };
        $('.insurance-container').html(html);
        $('#insurance-not-available').hide();
        $('#insurance-product').show();
      } else {
        html += '<div class="alert alert-warning" role="alert">'
        html += '<p>Lo sentimos, el precio ingresado excede la cobertura de las pólizas.</p>';
        html += '</div>'
        $('.insurance-sorry').html(html);
        $('#insurance-product').hide();
        $('#insurance-not-available').show();
      }
      
    }).catch(error => {
      console.log("Error al intentar obtener los precios: ", error);
    });
  },
  checkModalDatos: async function () {
    var self = this;
    ISApp.modalInsu = new bootstrap.Modal(document.getElementById('insuModal'), { keyboard: false }),
    ISApp.modalInsu.show();
    ISApp.objInsurance.title = $(self).find('h3').text();
    ISApp.objInsurance.price = $(self).find('.insurance-title').text().replace(/[S\/\.]/g, "").trim();
  },
  addToCart: function(event) {
    ISApp.objInsurance.type = $('#product-type').val();
    ISApp.objInsurance.brand = $('#brand').val();
    ISApp.objInsurance.model = $('#model').val();
    ISApp.objInsurance.purchaseDate = $('#purchase-date').val();
    ISApp.objInsurance.rut = $('#insu-rut').val();
    ISApp.objInsurance.rutType = $('[name="insu-rut-type"]:checked').val();
    ISApp.objInsurance.fnac = $('#insu-fnac').val();
    ISApp.objInsurance.productAmount = $('#purchase-price').val().replace("S/ ", "").replace(".00", "");
    
    const insuranceData = {
      plan: ISApp.objInsurance.title,
      price: ISApp.objInsurance.price
    };

    axios.post(ISApp.url.getCollection, insuranceData).then((response) => {
      console.log("response ==>", response);
      const insurance_id = response.data.data.variant_id;
      
      // Agregamos el seguro al carro
      let formData = {
       'items': [
         { 'id': insurance_id, 'quantity': 1 }
       ],
        'attributes': {
          'single_Insurance': insurance_id,
          'single_insurance_model':  ISApp.objInsurance.model,
          'single_insurance_rut': ISApp.objInsurance.rut,
          'single_insurance_rut_type': ISApp.objInsurance.rutType,
          'single_insurance_fnac': ISApp.objInsurance.fnac,
          'single_insurance_title': ISApp.objInsurance.title,
          'single_insurance_price': ISApp.objInsurance.price,
          'single_insurance_product_amount': ISApp.objInsurance.productAmount
       }
      };
      
      fetch(window.Shopify.routes.root + ISApp.url.addCart, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        window.location.href = '/cart'
      })
      .catch((error) => {
        console.error('Error al intentar agregar los productos al carro:', error);
      });
    }).catch(error => {
      console.log("Error al intentar obtener los productos de seguros: ", error);
    });

  }
};

$(document).ready(function() {
    ISApp.init();
});